import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from "flarum/common/components/Link";
import Widget from 'flarum/extensions/afrux-forum-widgets-core/common/components/Widget';

/**
 * 标签页热门模块【各个标签页】
 */
export default class HotTagDiscussion extends Widget {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.discussion = [];
  }

  oncreate(vnode) {
    const tag = m.route.param('tags');

    app.store
      .find('discussions', {
        sort: '-view_count',
        filter: { tag: tag || '' },
        page: { limit: 5 },
      })
      .then((results) => {
        this.discussion = results;
        this.loading = false;
        m.redraw();
      });
  }

  className() {
    return  'hot-discussion-widget ruko-widget';
  }

  title() {
    return  app.translator.trans('acme-ruko.forum.widget.hot_discussions');
  }

  content() {
    if (this.loading) {
      return <LoadingIndicator />;
    }
    return (
      <div className="Widget-SectionList">
        <ul className="section-ul">
          {this.discussion.map((disc, index) => {
            return (
              <li class="section-box tag-widget">
                <span className="tag-widget-left">{index + 1}</span>
                <Link className="section-box-discussion tag-widget-right" href={app.route.discussion(disc)} alt={disc.title()}>
                  {disc.title()}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}
